import React from 'react';
import { connect } from 'react-redux';
import { isEqual, get, find, sum } from 'lodash';

import CSV from '../../../helpers/CSVExport';

import ReactTable from "react-table";
import Box from '../Box';
import { statsActions } from '../../../data/actions/stats';
import StackedBarChart from '../../widgets/charts/types/StackedBarChart';
import LineChart from '../../widgets/charts/types/LineChart';
import DoughnutChart from '../../widgets/charts/types/DoughnutChart';
import { preAddSettings } from './PreAdd/Settings';
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
var barSvg = require('!svg-inline-loader!../../../../public/img/chart-bar.svg');
var lineSvg = require('!svg-inline-loader!../../../../public/img/line.svg');
var pieSvg = require('!svg-inline-loader!../../../../public/img/pie.svg');
var tableSvg = require('!svg-inline-loader!../../../../public/img/table.svg');

import VendorLogo from "../VendorLogo";
import { dspLogos } from "../../common/Stats/utils";
import ReactSelect from '../../common/ReactSelect';
import ModeSelect from '../ModeSelect';


class PreAdd extends React.Component {
	constructor(props) {
		super(props);
		const defaultSorted = [{id: 'total_pre_adds_and_pre_saves', desc: true}];
		this.state = {
		  mode: props.defaultMode || 'line',
		  logoDataFiltered: [],
		  metric: 'total',
		  defaultSorted: defaultSorted,
		  productId: -1
		};
		this.setChartMode = this.setChartMode.bind(this);
		this.exportToCsv = this.exportToCsv.bind(this);
		this.dispatchLoadData = this.dispatchLoadData.bind(this);
	}
	
	getDatasetLabel(metric){
		switch(metric) {
			case 'apple':
				return 'Apple Pre Add';
			case 'spotify':
				return 'Spotify Pre Saves';
			case 'total':
				return 'Total Pre-Add/Pre Save';					
		}
	}

	setChartMode(mode){
		this.setState({mode});
		const { modeChange } = this.props;
		
		if(typeof modeChange == 'function')
			modeChange(mode);
	}

	exportToCsv(){
		const filename = CSV.CSVHeader('pre_add', 'total', this.props.filter.global, this.props.parentEntityTitle); 
		return CSV.CSVExport(this.props.stats.preAdd.tableData, {filename}, 'pre_add');
	}
	
	componentDidMount() {
		this.dispatchLoadData();
	}
	
	
	componentWillReceiveProps(nextProps){
		const globalFilter = nextProps.filter.global;
		const { chartType, filtered } = this.props;

		
		if(nextProps.filter && globalFilter){
			if(this.props.filter.global!==undefined && !isEqual(globalFilter, this.props.filter.global)) {
				this.dispatchLoadData();
			}                
		}
	}
	
	dispatchLoadData(){
		const { filtered } = this.props;
		const { defaultSorted } = this.state;
		this.props.dispatch(statsActions.getPreAdd({
			sorted: defaultSorted,
			filtered
		}));
	}
	
	renderToolbar(products){
		const { mode } = this.state;
		let toolbar = [];
		const productValue = find(products, p=>p.value == this.state.productId)

		let options = [
			{icon: tableSvg, value: 'table', label: "Table"},
			{icon: pieSvg, value: 'pie', label: "Pie Chart"},
			{icon: lineSvg, value: 'line', label: "Line Chart"},
			{icon: barSvg, value: 'bar', label: "Bar Chart"}
		];

		toolbar.push(<div key="wrapper" className="ibox-action-wrapper">
			<div className="ibox-icon-holder mode-select">
			{mode !== 'table' && <ReactSelect options={products} value={productValue} onChange={o=>this.setState({productId: o.value})} className="single-select product-select" isSearchable={ false } />}
			<ModeSelect options={options} selected={mode} onChange={this.setChartMode} isSearchable={ false } />
		</div>
		</div>)
		return toolbar;
	}  

	renderExportToCsv() {
		return (
			<a key="download" title="Export CSV" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
		)
	}
	
	renderVendorLogos() {
		const { chartType } = this.props;
		const logoData = chartType ? this.state.logoDataFiltered : [];

		return <div className="title-vendors-list">
			{chartType && logoData && logoData.map((l) => (
				<VendorLogo key={l} name={l} />
			))}
		</div>
	}
	
	renderMetrics(){
		const metrics = ['apple', 'spotify', 'total'];
		const options = metrics.map(m=>({
			label: this.getDatasetLabel(m),
			value: m
		}));
		const value = find(options, o=>o.value == this.state.metric);
		return <div className='entity-selector-select entity-selector-select--inner'><ReactSelect options={options} value={value} onChange={(m)=>this.setState({metric: m.value})} className="single-select" isSearchable={ false } /></div>
	}
	
	getColors(preAdd, metric){
		return {
			backgroundColor: get(preAdd, `colors.${metric}`),
			borderColor: get(preAdd, `colors.${metric}`),
			pointBackgroundColor: get(preAdd, `colors.${metric}`),
			pointBorderColor: get(preAdd, `colors.${metric}`),
		}
	}
	
	renderTitle(tableData) {
		let title = 'Top Pre-Adds';
		let { filter } = this.props;
		if(tableData && tableData.length)
			title = `${title} (${tableData.length})`;
		else if(filter.global && filter.global.limit)
			title = `${title} (${filter.global.limit})`;
		   
		return title;
	}

	
	render (){
		const { preAdd, preAddLoading = true } = this.props.stats;
		const { productId, metric, mode, defaultSorted } = this.state;
		let { shadowChartProps, spotifyPreAddsAvailable, filtered, pageSize } = this.props;
		const { isAvailable, isPartialAvailability } = spotifyPreAddsAvailable;
		if(shadowChartProps){
			shadowChartProps.shadowChart = true;
		};
		
		let data= {
			labels: get(preAdd, 'labels', []),
		}
		let datasets = [{
			data: get(preAdd, `datasets.${productId}.${metric}`, []),
			label: this.getDatasetLabel(metric),
			...this.getColors(preAdd, metric)
		}];
		
		if( metric == 'total' && ['bar', 'line'].includes(mode)) { 
			
			const extraDatasets = [{
				data: get(preAdd, `datasets.${productId}.apple`, []),
				label: this.getDatasetLabel('apple'),
				...this.getColors(preAdd, 'apple')
			},
			{
				data: get(preAdd, `datasets.${productId}.spotify`, []),
				label: this.getDatasetLabel('spotify'),
				...this.getColors(preAdd, 'spotify')
			}];
			if(mode == 'bar') // stacked bar chart split
				datasets = extraDatasets;
			else 
				datasets = [...datasets, ...extraDatasets];	
			
		}
		data.datasets = datasets;
		
		
		let options = get(preAdd, 'options', []);
		
		const tableData = get(preAdd, 'tableData', []);
		const rows = tableData.length > 0 ? tableData.length : 10;
		
		let pieDataset = [
			sum(get(preAdd, `datasets.${productId}.apple`, [])),
			sum(get(preAdd, `datasets.${productId}.spotify`, []))
		];
		if(productId == -1) {
			pieDataset = get(preAdd, 'pieData', []);
		}
		
		const pieData = { 
			labels: [this.getDatasetLabel('apple'), this.getDatasetLabel('spotify')],
			datasets: [{ data: pieDataset, backgroundColor: [...Object.values(get(preAdd, 'colors', {}))]} ],
		}

		return <Box title={this.renderTitle(tableData)} toolbar={this.renderToolbar(options)} vendorLogoList={this.renderVendorLogos()} spinnerEnabled={preAddLoading} exportToCsv={this.renderExportToCsv()}>
			{isPartialAvailability && <div className="chart-warning-note"><p><strong>Please note:</strong> Spotify Pre Save data available since March 9 2026 only</p></div>}
				{mode=='table' && <div className="sources-table territory-table--single custom-scroll">
					{!preAddLoading && <ReactTable
						className="simple-table"
						data={tableData}
						defaultPageSize={tableData.length}
						columns={preAddSettings.settingsForTable("products", spotifyPreAddsAvailable)}
						showPagination={false}
						defaultSorted={defaultSorted}
						noDataText='No results found. Please check your filters.'
						
				/>}</div>}
				{mode=='pie' && <div className="chart-block">
					<DoughnutChart data={pieData} {...shadowChartProps} />                          
				</div>}
				{mode=='line' && <div className="chart-block">
					{this.renderMetrics()}
					{!preAddLoading && <LineChart data={data} {...shadowChartProps}  />}
				</div>}
				{mode=='bar' && <div className="chart-block">
					{this.renderMetrics()}
					{!preAddLoading && <StackedBarChart data={data} {...shadowChartProps}  />}
				</div>}
		</Box>
	}
}

function mapStateToProps(state) {
	return {
		stats: state.stats,
		filter: state.filter
	} 
}

export default connect(mapStateToProps)(PreAdd);